// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/menu.css */
:root {
  /* tokens principais (herdam do dashboard.css quando presente) */
  --bg: #0b0d12;
  --card: #11141b;
  --text: #e7edf6;
  --muted: #a6b0c3;
  --border: #1c2330;
  --brand: #22c55e;
  --brand-2: #16a34a;
  --menu-h: 72px;
  --radius: 16px;
  --shadow-soft: 0 6px 18px rgba(0,0,0,0.25);
}

/* Header (ocupa a altura do topo já reservada pelo layout) */
.menu-wrapper {
  height: var(--menu-h);
  display: grid;
  align-items: center;
  background: var(--bg);
}

.menu-inner {
  height: var(--menu-h);
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  padding: 0 clamp(12px, 3vw, 32px);
  max-width: 1200px;
  margin: 0 auto;
  gap: 12px;
}

/* Logo paisagem (retangular) — melhor adaptação mobile/desktop */
.menu-left {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
}
.menu-logo-landscape {
  height: 28px;
  width: auto;
  object-fit: contain;
  -webkit-user-select: none;
          user-select: none;
  filter: drop-shadow(0 6px 16px rgba(34,197,94,0.25));
}

/* Saudação central */
.menu-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
.menu-greet {
  font-size: 14px;
  color: var(--text);
  letter-spacing: 0.2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.menu-greet .hello { color: var(--muted); }
.menu-greet .username { font-weight: 800; }

/* Ações à direita */
.menu-right {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* Botão Editar mais discreto (ghost) */
.btn-mini {
  border: 1px solid var(--border);
  background: #0c0f14;
  color: var(--text);
  padding: 8px 10px;
  border-radius: 10px;
  font-weight: 700;
  cursor: pointer;
  transition: all .2s ease;
}
.btn-mini:hover { transform: translateY(-1px); box-shadow: var(--shadow-soft); }
.btn--ghost-mini {
  background: transparent;
  color: var(--muted);
  border: 1px solid var(--border);
}
.btn--ghost-mini:hover {
  color: var(--text);
  border-color: #263145;
}

/* Hamburger (mobile) */
.hamburger {
  background: transparent;
  border: 1px solid var(--border);
  border-radius: 10px;
  padding: 8px 10px;
  cursor: pointer;
}
.hamburger .line {
  display: block;
  width: 20px; height: 2px;
  background: var(--text);
  margin: 4px 0;
  transition: transform .25s ease, opacity .25s ease;
}
.hamburger .line.open:nth-child(1) { transform: translateY(6px) rotate(45deg); }
.hamburger .line.open:nth-child(2) { opacity: 0; }
.hamburger .line.open:nth-child(3) { transform: translateY(-6px) rotate(-45deg); }

/* Drawer (mobile) — agora FIXO logo abaixo do header, não fica escondido */
.menu-drawer {
  position: fixed;
  top: var(--menu-h);
  left: 0;
  right: 0;
  z-index: 70; /* acima do conteúdo do dashboard */
  max-height: 0;
  overflow: hidden;
  transition: max-height .25s ease-in-out;
  background: #0c0f14;
  border-bottom: 1px solid var(--border);
  box-shadow: 0 10px 24px rgba(0,0,0,0.35);
}
.menu-drawer.active { max-height: 260px; }

.menu-drawer ul {
  list-style: none;
  padding: 10px clamp(12px, 3vw, 32px);
  margin: 0;
  display: grid; gap: 8px;
}
.menu-drawer a, .menu-drawer .auth-button {
  display: block;
  padding: 12px 12px;
  color: var(--text);
  text-decoration: none;
  background: #0e1319;
  border: 1px solid var(--border);
  border-radius: 10px;
  font-weight: 700;
}
.menu-drawer a:hover, .menu-drawer .auth-button:hover {
  background: #0f151c;
}

/* Em telas médias/grandes, mantemos apenas a saudação e o botão Editar; esconde o drawer */
@media (min-width: 900px) {
  .hamburger { display: none; }
  .menu-drawer { display: none; }
}
`, "",{"version":3,"sources":["webpack://./src/components/menu.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;EACE,gEAAgE;EAChE,aAAa;EACb,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,0CAA0C;AAC5C;;AAEA,6DAA6D;AAC7D;EACE,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,iCAAiC;EACjC,iBAAiB;EACjB,cAAc;EACd,SAAS;AACX;;AAEA,iEAAiE;AACjE;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;AACA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,yBAAiB;UAAjB,iBAAiB;EACjB,oDAAoD;AACtD;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA,qBAAqB,mBAAmB,EAAE;AAC1C,wBAAwB,gBAAgB,EAAE;;AAE1C,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,uCAAuC;AACvC;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,wBAAwB;AAC1B;AACA,kBAAkB,2BAA2B,EAAE,8BAA8B,EAAE;AAC/E;EACE,uBAAuB;EACvB,mBAAmB;EACnB,+BAA+B;AACjC;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA,uBAAuB;AACvB;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,cAAc;EACd,WAAW,EAAE,WAAW;EACxB,uBAAuB;EACvB,aAAa;EACb,kDAAkD;AACpD;AACA,qCAAqC,wCAAwC,EAAE;AAC/E,qCAAqC,UAAU,EAAE;AACjD,qCAAqC,0CAA0C,EAAE;;AAEjF,2EAA2E;AAC3E;EACE,eAAe;EACf,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,WAAW,EAAE,mCAAmC;EAChD,aAAa;EACb,gBAAgB;EAChB,uCAAuC;EACvC,mBAAmB;EACnB,sCAAsC;EACtC,wCAAwC;AAC1C;AACA,sBAAsB,iBAAiB,EAAE;;AAEzC;EACE,gBAAgB;EAChB,oCAAoC;EACpC,SAAS;EACT,aAAa,EAAE,QAAQ;AACzB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;;AAEA,2FAA2F;AAC3F;EACE,aAAa,aAAa,EAAE;EAC5B,eAAe,aAAa,EAAE;AAChC","sourcesContent":["/* src/components/menu.css */\n:root {\n  /* tokens principais (herdam do dashboard.css quando presente) */\n  --bg: #0b0d12;\n  --card: #11141b;\n  --text: #e7edf6;\n  --muted: #a6b0c3;\n  --border: #1c2330;\n  --brand: #22c55e;\n  --brand-2: #16a34a;\n  --menu-h: 72px;\n  --radius: 16px;\n  --shadow-soft: 0 6px 18px rgba(0,0,0,0.25);\n}\n\n/* Header (ocupa a altura do topo já reservada pelo layout) */\n.menu-wrapper {\n  height: var(--menu-h);\n  display: grid;\n  align-items: center;\n  background: var(--bg);\n}\n\n.menu-inner {\n  height: var(--menu-h);\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  align-items: center;\n  padding: 0 clamp(12px, 3vw, 32px);\n  max-width: 1200px;\n  margin: 0 auto;\n  gap: 12px;\n}\n\n/* Logo paisagem (retangular) — melhor adaptação mobile/desktop */\n.menu-left {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n}\n.menu-logo-landscape {\n  height: 28px;\n  width: auto;\n  object-fit: contain;\n  user-select: none;\n  filter: drop-shadow(0 6px 16px rgba(34,197,94,0.25));\n}\n\n/* Saudação central */\n.menu-center {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.menu-greet {\n  font-size: 14px;\n  color: var(--text);\n  letter-spacing: 0.2px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.menu-greet .hello { color: var(--muted); }\n.menu-greet .username { font-weight: 800; }\n\n/* Ações à direita */\n.menu-right {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n/* Botão Editar mais discreto (ghost) */\n.btn-mini {\n  border: 1px solid var(--border);\n  background: #0c0f14;\n  color: var(--text);\n  padding: 8px 10px;\n  border-radius: 10px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all .2s ease;\n}\n.btn-mini:hover { transform: translateY(-1px); box-shadow: var(--shadow-soft); }\n.btn--ghost-mini {\n  background: transparent;\n  color: var(--muted);\n  border: 1px solid var(--border);\n}\n.btn--ghost-mini:hover {\n  color: var(--text);\n  border-color: #263145;\n}\n\n/* Hamburger (mobile) */\n.hamburger {\n  background: transparent;\n  border: 1px solid var(--border);\n  border-radius: 10px;\n  padding: 8px 10px;\n  cursor: pointer;\n}\n.hamburger .line {\n  display: block;\n  width: 20px; height: 2px;\n  background: var(--text);\n  margin: 4px 0;\n  transition: transform .25s ease, opacity .25s ease;\n}\n.hamburger .line.open:nth-child(1) { transform: translateY(6px) rotate(45deg); }\n.hamburger .line.open:nth-child(2) { opacity: 0; }\n.hamburger .line.open:nth-child(3) { transform: translateY(-6px) rotate(-45deg); }\n\n/* Drawer (mobile) — agora FIXO logo abaixo do header, não fica escondido */\n.menu-drawer {\n  position: fixed;\n  top: var(--menu-h);\n  left: 0;\n  right: 0;\n  z-index: 70; /* acima do conteúdo do dashboard */\n  max-height: 0;\n  overflow: hidden;\n  transition: max-height .25s ease-in-out;\n  background: #0c0f14;\n  border-bottom: 1px solid var(--border);\n  box-shadow: 0 10px 24px rgba(0,0,0,0.35);\n}\n.menu-drawer.active { max-height: 260px; }\n\n.menu-drawer ul {\n  list-style: none;\n  padding: 10px clamp(12px, 3vw, 32px);\n  margin: 0;\n  display: grid; gap: 8px;\n}\n.menu-drawer a, .menu-drawer .auth-button {\n  display: block;\n  padding: 12px 12px;\n  color: var(--text);\n  text-decoration: none;\n  background: #0e1319;\n  border: 1px solid var(--border);\n  border-radius: 10px;\n  font-weight: 700;\n}\n.menu-drawer a:hover, .menu-drawer .auth-button:hover {\n  background: #0f151c;\n}\n\n/* Em telas médias/grandes, mantemos apenas a saudação e o botão Editar; esconde o drawer */\n@media (min-width: 900px) {\n  .hamburger { display: none; }\n  .menu-drawer { display: none; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
